import { createContext } from 'react';
import { ShapeDiverValue } from '../shape-diver';
import { noop } from 'rxjs';

export type ExportRequest = {
  exportName: string;
  values: Record<string, ShapeDiverValue>;
};

type ExportContextType = {
  requestExport: (data: ExportRequest) => void;
};

const ExportContext = createContext<ExportContextType>({
  requestExport: noop,
});

export default ExportContext;
